import { render } from "./EventCard.vue?vue&type=template&id=fcd7a540&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=fcd7a540&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fcd7a540"

export default script